import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, md } from 'vuetify/iconsets/md';
import 'vuetify/styles';
import { en as vuetifyEn, es as vuetifyEs } from 'vuetify/locale';
import appEn from '@/i18n/lang/en';
import appEs from '@/i18n/lang/es';

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'md',
    aliases,
    sets: { md },
  },
  locale: {
    locale: 'en',
    fallback: 'en',
    messages: {
      en: { ...vuetifyEn, ...appEn },
      es: { ...vuetifyEs, ...appEs },
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#4d79af',
          error: '#ee0000',
        },
      },
    },
  },
});
